import Container from '~/components/layout/Container';
import ServiceCard from '../features/ServiceCard';

const ServicesSection = () => {
  const services = [
    {
      title: 'UTB Trader & Trade Platformuna Stratejik Destek',
      subtitle: 'Etkin Çözümlerle Yanınızdayız',
      description: 'UTB Support olarak, UTB Trader & Trade platformunun başarısını ve sürdürülebilirliğini sağlamak için kapsamlı destek hizmetleri sunuyoruz. Amacımız, platform kullanıcılarının ihtiyaç duyduğu bilgiye ulaşmalarını sağlamak, ticari işlemlerini kolaylaştırmak ve karşılaştıkları sorunlarda hızlı çözümler sunarak süreçlerini sorunsuz bir şekilde ilerletmelerine yardımcı olmaktır.',
      imageSrc: '/assets/UTB-Trader-Trade-Platformuna-Stratejik-Destek.webp',
      imageAlt: 'Strategic Support Image'
    },
    {
      title: 'Platform Üyelerine Danışmanlık ve Rehberlik',
      subtitle: 'Uzman Kadro ile Danışmanlık Hizmetleri',
      description: 'UTB Support, UTB Trader & Trade platformunda yer alan Türk firmaları ve yabancı kullanıcılar için özelleştirilmiş danışmanlık ve rehberlik hizmetleri sunar. Platformun sunduğu tüm fırsatları en iyi şekilde değerlendirebilmeleri için üyelerimize, ihracat, ithalat, hedef pazar ve müşteri analizleri gibi birçok alanda destek sağlıyoruz.',
      imageSrc: '/assets/Platform-Uyelerine-Danismanlik-ve-Rehberlik.webp',
      imageAlt: 'Consulting Services Image'
    },
    {
      title: 'Eğitimler ve Bilgi Paylaşımı',
      subtitle: 'Ticarette Fark Yaratan Eğitimler',
      description: 'UTB Support olarak, UTB Trader & Trade platform kullanıcılarının bilgi seviyelerini artırmak ve ticari süreçlerde kendilerini geliştirmelerine yardımcı olmak için eğitimler ve bilgi paylaşım etkinlikleri düzenliyoruz. Uluslararası lojistik operasyonlarından gümrük süreçlerine kadar geniş bir yelpazede sunduğumuz eğitim programları ile üyelerimizin ticari rekabet gücünü artırmayı hedefliyoruz.',
      imageSrc: '/assets/Egitimler-ve-Bilgi-Paylasimi.webp',
      imageAlt: 'Training and Knowledge Sharing Image'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <Container className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <ServiceCard
              key={service.title}
              title={service.title}
              subtitle={service.subtitle}
              description={service.description}
              imageSrc={service.imageSrc}
              imageAlt={service.imageAlt}
            />
          ))}
        </div>
      </Container>
    </section>
  );
};

export default ServicesSection;